import React from 'react'
import './CreatorStandard.css'
import logo from '../../../assets/img/logo.png'
import heroNew from '../../../assets/img/hero-new.png'
import driveLogo from '../../../assets/img/googledrive.png'
import { ArrowDropDownRounded, Add, ArrowRight, ArrowForward, Check, DoneAll, SearchSharp, CheckCircle, DoneOutline, Done, ArrowBack, CheckOutlined, CloudDone, AttachFile, Attachment, CloudOff, Cancel, OpenInBrowser, ArrowDownward, KeyboardArrowDown } from '@material-ui/icons'
import Modal from 'react-modal'
import { Link } from 'react-router-dom'
import Unsplash from 'unsplash-js'
import axios from 'axios'
import GooglePicker from 'react-google-picker'
import DropboxChooser from 'react-dropbox-chooser'

import * as firebase from "firebase/app"
import "firebase/auth"

import { API_URL } from '../../../config'
import PaygeItem from '../../../components/PaygeItem/PaygeItem'

const yt_modal_styles = {
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		width: '60%',
		marginRight: '-50%',
		transform: 'translate(-50%, -50%)',
		padding: 0,
		background: '#0091EA',
		borderRadius: 0,
	}
}

const img_one = "https://images.unsplash.com/photo-1561016444-14f747499547?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1489&q=80"
const default_background = {
  index: 0,
  imgSearchQuery: 'payge_default_background_image',
  urls: {
    regular: img_one
  },
  user: {
    name: "Jason Dent",
    links: {html: "https://unsplash.com/@jdent"}
  }
}

// Pipeline Steps
const pipelineSteps = ['Download File', 'Page Details', 'Appearance', 'Get your Payge']

// API setups
const unsplash = new Unsplash({ accessKey: "Besw1gJSUAJg5eHf3vgVESKrM_VPp6MY2xO4SXnGqX8" });
const DRIVE_API_KEY = "AIzaSyDrDdmRMzPZdInG6O9uTVrfslh82gXBcAc"

export default class CreatorStandard extends React.Component {

  constructor(props) {
    super(props)
    this.content = React.createRef()
    this.state = {
      selected_theme: "one",
      video_isopen: false,
      backgrounds: [],
      selected_bg: default_background,
      img_search_text: undefined,
      payge_created: false,
      is_loading: false,
      copyLabelText: 'Copy to clipboard',
      input_errors: [false, false, false],
      driveLinkValid: false,
      // 0 - pending, 1 - success, 2 - error
      driveSelectedFlag: 0,
      pipelineStepStates: [0, 0, 0, 0],
      error_indicator_mode: false,
      fileUrlInput: undefined,
      fileNameInput: undefined,
      fileDescriptionInput: undefined,
      driveFile: undefined,
      dropboxFile: undefined,
      new_payge_data: undefined,
      userUid: undefined,
      isFileSelectOpen: true,
      pipelineStep: 0,
      isPipelineFlow: true,
      fileProviderStates: [0, 0]
    }
  }

  setSelectedTheme = (theme) => {
    this.setState({selected_theme: theme})
  }

  closeYouTubeModal = () => {
    if (this.state.video_isopen) {
      this.setState({video_isopen: false})
    }
  }

  // handling Input changes
  handleFileURLTextChange = (e) => {
    let input = e.target.value
    let new_errors = this.state.input_errors
    // checking for empty input
    if (input.trim() === '') {
      new_errors[0] = true
    } else {
      new_errors[0] = false
    }
    this.setState({
      fileUrlInput: input,
      input_errors: new_errors,
      driveLinkValid: false,
    })
  }
  handleFileNameTextChange = (e) => {
    let input = e.target.value
    let new_errors = this.state.input_errors
    // checking for empty input
    if (input.trim() === '') {
      new_errors[1] = true
    } else {
      new_errors[1] = false
    }
    this.setState({
      fileNameInput: input,
      input_errors: new_errors
    })
  }
  handleFileDescriptionTextChange = (e) => {
    let input = e.target.value
    let new_errors = this.state.input_errors
    // checking for empty input
    if (input.trim() === '') {
      new_errors[2] = true
    } else {
      new_errors[2] = false
    }
    this.setState({
      fileDescriptionInput: input,
      input_errors: new_errors
    })
  }

  // copying to clipboard
  copyLinkToClipboard = (link) => {
    let context = this
    navigator.permissions.query({name: "clipboard-write"}).then(result => {
      if (result.state == "granted" || result.state == "prompt") {
        // writing link to clipboard
        navigator.clipboard.writeText(link).then(function() {
          console.log("clipboard copied")
          // quick UI changes
          context.showCopyUIChanges()
        }, function() {
          console.log("clipboard error")
        });
      }
    });
  }
  showCopyUIChanges = () => {
    this.setState({copyLabelText: 'Copied'})
    setTimeout(() => {
      this.setState({copyLabelText: 'Copy to clipboard'})
    }, 500)
  }

  // selecting a bg
  selectBg = (index) => {
    let bg = this.state.backgrounds[index]
    bg["index"] = index
    bg["imgSearchQuery"] = this.state.img_search_text
    this.setState({
      selected_bg: bg
    })
  }

  // navbar functions
  handlePipelineNext = () => {
    const { pipelineStep, driveLinkValid, fileProviderStates, pipelineStepStates, fileNameInput, fileDescriptionInput } = this.state
    // handling next validations
    switch (pipelineStep) {
      case 0:
        if (driveLinkValid || fileProviderStates[0] === 1 || fileProviderStates[1] === 1) {
          pipelineStepStates[pipelineStep] = 1
        } else {
          pipelineStepStates[pipelineStep] = 2
        }
        break
      case 1:
        if (fileNameInput && fileNameInput.trim() !== "" && fileDescriptionInput && fileDescriptionInput.trim() !== "") {
          pipelineStepStates[pipelineStep] = 1
        } else {
          pipelineStepStates[pipelineStep] = 2
        }
        break
      case pipelineSteps.length-2:
        if (this.handleCreatePayge()) {
          return
        } else {
          pipelineStepStates[pipelineStep] = 1
          break
        }
      case pipelineSteps.length-1:
        let url = '/dashboard'
        if (this.state.new_payge_data) {
          url = this.state.new_payge_data.paygeUrl
        }
        window.open(url, '_blank')
    }

    window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
    if (pipelineStep !== pipelineSteps.length-1) {
      this.setState({pipelineStep: pipelineStep+1, pipelineStepStates: pipelineStepStates})
    }
  }
  handlePipelineBack = () => {
    const { pipelineStep, driveLinkValid, driveSelectedFlag, pipelineStepStates } = this.state
    // handling back validation
    switch (pipelineStep) {
      case pipelineSteps.length-1:
        window.open('/dashboard', '_self')
        return
      default:
        pipelineStepStates[pipelineStep-1] = 0
        break
    }
    window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
    if (pipelineStep !== 0) {
      this.setState({pipelineStep: pipelineStep-1, pipelineStepStates: pipelineStepStates})
    }
  }

  // img search text change
  handleImageSearchTextChange = (e) => {
    this.setState({
      img_search_text: e.target.value
    })
    // disabled due to rate limiting
    // this.getUnsplashImages(e.target.value)
  }
  handleOnKeyDown = (e) => {
		if (e.keyCode === 13) this.getUnsplashImages(e.target.value)
	}

  // search for images from unsplash
  getUnsplashImages = (search) => {
    unsplash.search.photos(search, 1, 40)
      .then(res => res.json())
      .then(json => {
        console.log(json)
        let selected_bg = default_background
        let backgrounds = json.results
        if (backgrounds.length > 0) {
          selected_bg = backgrounds[0]
          selected_bg["index"] = 0
          selected_bg["imgSearchQuery"] = search
        } 
        this.setState({
          backgrounds: backgrounds,
          selected_bg: selected_bg,
        })
      });
  }

  // verify google drive file 
  verifyDriveFile = () => {
    let input = this.state.fileUrlInput
    let new_errors = this.state.input_errors
    let driveLinkValid = this.state.driveLinkValid
    this.setState({driveFile: undefined, driveSelectedFlag: 0})

    if (!input) {return}
    // checking if it's a valid gdrive file
    let fileId = undefined
    if (input.slice(0, 24) === "drive.google.com/file/d/" || input.slice(0, 32) === "https://drive.google.com/file/d/" || input.slice(0, 31) === "http://drive.google.com/file/d/") {
      let dashSplit = input.split('/file/d/')[1]
      fileId = dashSplit.split('/')[0]
    } else if (input.slice(0, 17) === "drive.google.com/" || input.slice(0, 25) === "https://drive.google.com/" || input.slice(0, 24) === "http://drive.google.com/") {
      // checking for valid file id
      let querySplit = input.split('?')
      if (querySplit.length > 1) {
        let queries = querySplit[1].split('&')
        for (var i=0;i<queries.length;i++) {
          let query = queries[i]
          if (query.slice(0, 3) === "id=") {
            fileId = query.split('=')[1]
          }
        }
      }
    }
    if (fileId.length > 1 && fileId) {
      // getting file metadata
      axios(`https://www.googleapis.com/drive/v2/files/${fileId}?key=${DRIVE_API_KEY}`)
        .then((result) => {
          let driveFile = undefined
          if (result.status === 200) {
            driveLinkValid = true
            driveFile = result.data
          } else {
            driveLinkValid = false
            new_errors[0] = true
          }
          this.setState({
            input_errors: new_errors,
            driveLinkValid: driveLinkValid,
            driveFile: driveFile
          })
        },
        (error) => {
          driveLinkValid = false
          new_errors[0] = true
          this.setState({
            input_errors: new_errors,
            driveLinkValid: driveLinkValid,
            driveFile: undefined
          })
        }
      )
    }
  }

  // When a file is selected from Google Picker
  onDriveSelectDataChange = (data) => {
    if (data.docs) {
      this.setState({
        driveFile: undefined, 
        driveLinkValid: false, 
        dropboxFile: undefined, 
        fileProviderStates: [0, 0]
      })
      console.log(data.docs[0])
      let fileId = data.docs[0].id
      // getting file info
      axios(`https://www.googleapis.com/drive/v2/files/${fileId}?key=${DRIVE_API_KEY}`)
      .then((result) => {
        let driveFile = undefined
        let driveSelectedFlag = 0
        if (result.status === 200) {
          driveFile = result.data
          driveSelectedFlag = 1
        } else {
          driveSelectedFlag = 2
        }
        this.setState({
          driveFile: driveFile,
          driveSelectedFlag: driveSelectedFlag,
          fileProviderStates: [driveSelectedFlag, 0]
        })
      },
      (error) => {
        this.setState({
          driveSelectedFlag: 2,
          driveFile: undefined,
          fileProviderStates: [2, 0]
        })
      })
    }
  }
  // When a file is selected from Dropbox Chooser
  onDropboxChooseDataChange = (files) => {
    if (files) {
      let currentFile = files[0]
      console.log(currentFile)
      this.setState({
        driveFile: undefined, 
        driveLinkValid: false, 
        dropboxFile: currentFile, 
        fileProviderStates: [0, 1]
      })
    } else {
      this.setState({
        driveFile: undefined, 
        driveLinkValid: false, 
        dropboxFile: undefined, 
        fileProviderStates: [0, 2]
      })
    }
  }

  // create payge
  handleCreatePayge = () => {
    const { fileUrlInput, fileNameInput, fileDescriptionInput, input_errors, selected_bg, 
      driveLinkValid, driveFile, selected_theme, userUid, driveSelectedFlag, dropboxFile, fileProviderStates } = this.state

    // showing pipeline error for a short time
    this.setState({error_indicator_mode: true})
    setTimeout(() => {
      this.setState({error_indicator_mode: false})
    }, 2500)

    if ((!fileUrlInput || fileUrlInput.trim() === "" || !driveLinkValid) && (!driveFile && driveSelectedFlag === 1)) {
      input_errors[0] = true
    }
    if (!fileNameInput || fileNameInput.trim() === "") {
      input_errors[1] = true
    }
    if (!fileDescriptionInput || fileDescriptionInput.trim() === "") {
      input_errors[2] = true
    }
    // scrolling to top
    window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
    // setting errors
    this.setState({
      input_errors: input_errors
    })
    if (!input_errors[0] && !input_errors[1] && !input_errors[2] && selected_bg && userUid && (driveFile || dropboxFile)) {
      // Getting data
      let url = `${API_URL}/payge/new`
      let postData = {
        driveFile: driveFile,
        downloadName: fileNameInput,
        downloadDescription: fileDescriptionInput,
        backgroundImage: selected_bg,
        paygeTheme: selected_theme,
        ownerUser: userUid
      }
      // checking for file data
      if ((fileProviderStates[0] === 1 && driveFile) || (driveFile && driveLinkValid)) {
        postData['driveFile'] = driveFile
        postData['fileProvider'] = 'GoogleDrive'
      } else if (fileProviderStates[1] === 1 && dropboxFile) {
        postData['dropboxFile'] = dropboxFile
        postData['fileProvider'] = 'Dropbox'
      } else {
        return true
      }

      // loading indicator
      window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
      this.setState({
        is_loading: true
      })

      // calling the API
      axios({
        method: 'POST',
        url: url,
        headers: {
          'Content-Type': 'application/json',
        },
        data: postData
      })
        .then((result) => {
          let is_loading = false
          let payge_created = false
          let new_payge_data = undefined
          if (result.status === 200) {
            if (result.data.status === "success") {
              payge_created = true
              new_payge_data = result.data.payge
            }
            // triggering download for unsplash photo
            unsplash.photos.downloadPhoto(selected_bg)
          } else {
            this.handlePipelineBack()
          }
          this.setState({
            is_loading: is_loading,
            payge_created: payge_created,
            new_payge_data: new_payge_data
          })
        },
        (error) => {
          this.handlePipelineBack()
          this.setState({
            is_loading: false,
            payge_created: false
          })
        })

    } else {
      return true
    }
  }

  componentWillMount() {
    let self = this
    // getting auth user
    firebase.auth().onAuthStateChanged(function(user) {
      if (user) {
        // User is signed in.
        self.setState({userUid: user.uid})
      } else {
        // User is signed out.
        window.open('/', '_self')
        return
      }
    })
  }
  componentDidMount() {
    // getting unsplash
    this.getUnsplashImages("interior")
  }

  render() {
    const { selected_theme, video_isopen, backgrounds, selected_bg, img_search_text, payge_created, driveLinkValid, userUid,
      copyLabelText, is_loading, input_errors, fileUrlInput, fileNameInput, fileDescriptionInput, driveFile, new_payge_data,
      driveSelectedFlag, isFileSelectOpen, pipelineStep, pipelineStepStates, error_indicator_mode, isPipelineFlow,
      dropboxFile, fileProviderStates } = this.state

    // getting theme
    let theme_one_style = ""
    let theme_two_style = ""
    let theme_three_style = ""
    if (selected_theme === "one") {
      theme_one_style = "active"
    } else if (selected_theme === "two") {
      theme_two_style = "active"
    } else if (selected_theme === "three") {
      theme_three_style = "active"
    }

    // setting error for input views
    let inputOneStyles = 'black'
    let inputTwoStyles = 'black'
    let inputThreeStyles = 'black'
    if (input_errors[0]) {
      inputOneStyles = 'red'
    }
    if (input_errors[1]) {
      inputTwoStyles = 'red'
    }
    if (input_errors[2]) {
      inputThreeStyles = 'red'
    }
    if (driveLinkValid) {
      inputOneStyles = 'green'
    }
    // styles for drive select button
    let driveButtonStyles = 'blue'
    let driveButtonText = 'Select file from Google Drive'
    if (driveSelectedFlag === 1) {
      driveButtonStyles = 'green'
      driveButtonText = driveFile.title
    } else if (driveSelectedFlag === 2) {
      driveButtonStyles = 'red'
      driveButtonText = (<>Click to try again! —&nbsp;<span className="small-text">Make sure the file is publicly viewable</span></>)
    }
    // styles for file provider buttons
    let gDriveButtonStyles = 'gray'
    let dropboxButtonStyles = 'gray'
    if (fileProviderStates[0] === 1) {
      gDriveButtonStyles = 'blue'
    } else if (fileProviderStates[0] === 2) {
      gDriveButtonStyles = 'red'
    }
    if (fileProviderStates[1] === 1) {
      dropboxButtonStyles = 'blue'
    } else if (fileProviderStates[1] === 2) {
      dropboxButtonStyles = 'red'
    }

    // styles for the pipeline
    let pipeline_errors = []
    pipelineStepStates.map((status) => {
      let value = 'none'
      if (status === 2 && error_indicator_mode) { value = 'error' }
      pipeline_errors.push(value)
    })

    // getting the pipeline views
    let fileElement = (
      <div className="question-container main-url">
        <div className="question-text-container">
          <span className="question-text">Select your Download file</span>
          <span className="what-action" onClick={() => this.setState({video_isopen: true})}>?</span>
        </div>

        {/* File Providers */}
        <div className="file-options-container">
          <ul className="file-providers">
            <GooglePicker 
              clientId={'678604044547-incnhojndefjdjv63md3fsbk5vo0ccvc.apps.googleusercontent.com'}
              developerKey={'AIzaSyDrDdmRMzPZdInG6O9uTVrfslh82gXBcAc'}
              scope={['https://www.googleapis.com/auth/drive.file']}
              onChange={data => this.onDriveSelectDataChange(data)}
              onAuthFailed={data => console.log('on auth failed:', data)}
              multiselect={false}
              navHidden={false}>
              <li className={gDriveButtonStyles}>
                <img src={driveLogo}/>
                <span>Google Drive</span>
              </li>
            </GooglePicker>
            <DropboxChooser 
              appKey={'cjwxs1ps6pj49sq'}
              success={files => this.onDropboxChooseDataChange(files)}
              linkType={'direct'} >
              <li className={dropboxButtonStyles}>
                <img src={"https://cfl.dropboxstatic.com/static/images/logo_catalog/dropbox_logo_glyph_m1.svg"}/>
                <span>Dropbox</span>
              </li>      
            </DropboxChooser>
          </ul>
          {/* <div className="status-container">
            TODO
          </div> */}
        </div>

        {/* <GooglePicker 
          clientId={'678604044547-incnhojndefjdjv63md3fsbk5vo0ccvc.apps.googleusercontent.com'}
          developerKey={'AIzaSyDrDdmRMzPZdInG6O9uTVrfslh82gXBcAc'}
          scope={['https://www.googleapis.com/auth/drive.file']}
          onChange={data => this.onDriveSelectDataChange(data)}
          onAuthFailed={data => console.log('on auth failed:', data)}
          multiselect={false}
          navHidden={false}>
          <div className={"drive-select-btn " + driveButtonStyles}>
            {
              driveSelectedFlag === 1 ? (
                <CloudDone className="icon" />
              ) : driveSelectedFlag === 2 ? (
                <CloudOff className="icon" />
              ) : (
                <img src="https://www.gstatic.com/images/branding/product/1x/drive_48dp.png" className="icon"/>
              )
            }
            <span>{driveButtonText}</span>
          </div>
        </GooglePicker> */}

        <div className="custom-hr"><span className="file-or">or</span></div>

        <div className="file-url-container">
          <input 
            type="url" 
            placeholder="Paste Google Drive file link here" 
            className={`input ${inputOneStyles}`}
            value={fileUrlInput}
            onChange={this.handleFileURLTextChange.bind(this)} />
          <div className={`get-file-btn ${inputOneStyles}`} onClick={this.verifyDriveFile.bind(this)}>
            <CloudDone className="icon" />
            <span>{ driveLinkValid ? driveFile.title : input_errors[0] ? "Couldn't get your file" : "Click to verify file link"}</span>
          </div>
        </div>

      </div>
    )
    let detailsElement = (
      <>
        <div className="question-container">
          <div className="question-text-container">
            <span className="question-text">Download Name</span>
            {/* <span className="what-action">?</span> */}
          </div>
          <input 
            type="url" 
            placeholder="Enter a name for the download page" 
            className={`input ${inputTwoStyles}`}
            value={fileNameInput}
            onChange={this.handleFileNameTextChange.bind(this)}/>
        </div>
        <div className="question-container">
          <div className="question-text-container">
            <span className="question-text">Download Description</span>
            {/* <span className="what-action">?</span> */}
          </div>
          <textarea 
            type="url" 
            placeholder="Let people know what your download is!" 
            className={`input ${inputThreeStyles}`}
            value={fileDescriptionInput}
            onChange={this.handleFileDescriptionTextChange.bind(this)}/>
        </div>
      </>
    )
    let appearanceElement = (
      <>
        <div className="question-container">
          <div className="question-text-container">
            <span className="question-text">Payge Background Image</span>
          </div>
          <div className="img-search-bar">
            <input 
              type="text" placeholder="Search for background images..."
              onChange={this.handleImageSearchTextChange.bind(this)}
              onKeyDown={this.handleOnKeyDown} />
            <SearchSharp className="icon" ref="imgSearchInput" onClick={() => this.getUnsplashImages(img_search_text)} />
          </div>
          <ul className="backgrounds">
            {
              backgrounds.slice(0, 40).map((bg, index) => {
                let liStyle = "inactive"
                if (index === selected_bg.index) {
                  liStyle = "active"
                }
                return (
                  <li className={liStyle} onClick={() => this.selectBg(index)}>
                    <img src={bg.urls.thumb} />
                  </li>
                )
              })
            }
          </ul>
          <span className="unsplash-attributions">Photos by respective artists on <a href="https://unsplash.com" target="_blank">Unsplash</a></span>
        </div>
      </>
    )
    let previewElement = (
      <>
        <span className="preview-text">Select a theme for your Payge</span>
        <span className="device-support">Please use the desktop version for Payge preview.</span>
        <div className="payge-layout">
          <ul className="themes">
            <li className={theme_one_style} onClick={() => this.setSelectedTheme("one")}>
              <div style={{display:'flex', alignItems: 'center', flex: 1, justifyContent: 'center'}} >
                <div className="one" />
              </div>
            </li>
            <li className={theme_two_style} onClick={() => this.setSelectedTheme("two")}>
              <div className="two" />
            </li>
            <li className={theme_three_style} onClick={() => this.setSelectedTheme("three")}>
              <div className="three" />
            </li>
          </ul>
          <div className={"preview-container " + selected_theme}>
            <img src={selected_bg.urls.regular} className="preview-bg" />
            <PaygeItem 
              theme={selected_theme} 
              name={fileNameInput} 
              description={fileDescriptionInput} 
              isLoaded={true} driveFile={driveFile}
              isDemo={true} />
          </div>
        </div>
        <KeyboardArrowDown className="down-icon"/>
        <div className="bg-layout question-container">
          <div className="question-text-container">
            <span className="question-text">Payge Background Image</span>
          </div>
          <div className="img-search-bar">
            <input 
              type="text" placeholder="Search for background images..."
              onChange={this.handleImageSearchTextChange.bind(this)}
              onKeyDown={this.handleOnKeyDown} />
            <SearchSharp className="icon" ref="imgSearchInput" onClick={() => this.getUnsplashImages(img_search_text)} />
          </div>
          <ul className="backgrounds">
            {
              backgrounds.slice(0, 40).map((bg, index) => {
                let liStyle = "inactive"
                if (index === selected_bg.index) {
                  liStyle = "active"
                }
                return (
                  <li className={liStyle} onClick={() => this.selectBg(index)}>
                    <img src={bg.urls.thumb} />
                  </li>
                )
              })
            }
          </ul>
          <span className="unsplash-attributions">Photos by respective artists on <a href="https://unsplash.com" target="_blank">Unsplash</a></span>
        </div>
      </>
    )
    // setting up get payge element
    let getPaygeElemenet = false
    if (is_loading) {
      getPaygeElemenet = (
        <>
          <div class="shimmer-container">
            <div className="name shimmer" />
            <div className="description shimmer" />
            <div className="description shimmer" />
            <div className="description shimmer" />
            <div className="description shimmer short" />
          </div>
        </>
      )
    } else if (new_payge_data) {
      getPaygeElemenet = (
        <>
          <div className="success-container">
            <span className="done-text">Your download Payge is ready!</span>
            <div className="link-container">
              <a href={new_payge_data.paygeUrl} target="_blank" style={{textDecoration: 'none'}}>
                <span className="link"><span className="payge-url-text">Payge Link —&nbsp;</span><b>{new_payge_data.paygeUrl}</b></span>
              </a>
              <span className="copy" onClick={()=>this.copyLinkToClipboard(new_payge_data.paygeUrl)}>{copyLabelText}</span>
            </div>
          </div>
        </>
      )
    }

    // getting the current pipeline element
    let currentPipelineElement = false
    switch(pipelineStep) {
      case 0:
        currentPipelineElement = fileElement
        break
      case 1:
        currentPipelineElement = detailsElement
        break
      case pipelineSteps.length-2:
        currentPipelineElement = previewElement
        break
      case pipelineSteps.length-1:
        currentPipelineElement = getPaygeElemenet
        break
    }
 
    return (
      <>
        {
          userUid ? (
            <div onClick={this.closeYouTubeModal.bind(this)} id="creator">
              <section className="creator-standard-topbar">
                <div className="logo">
                  <a href="/dashboard" style={{display: 'flex'}}>
                    <img src={logo} className="logo-img" />
                  </a>
                  <a href="/dashboard" style={{textDecoration: 'none'}}>
                    <span className="page-title">Payge</span>
                  </a>
                  <span className="creator-title">Creator</span>
                </div>
              </section>

              {
                !payge_created && !is_loading && !isPipelineFlow ? (
                  <section id="page-details-section">
                    <div className="new-ui-message">
                      <span>Hey! Want to try out a new beta version of Payge Creator?</span>
                      <a href='/creator/new' style={{textDecoration: 'none'}}><span className="try-btn">Let's Go!</span></a>
                    </div>
                    <div className="question-container main-url">
                      <div className="question-text-container">
                        <span className="question-text">Your Download File</span>
                        <span className="what-action" onClick={() => this.setState({video_isopen: true})}>?</span>
                      </div>

                      {
                        isFileSelectOpen ? (
                          <GooglePicker 
                            clientId={'678604044547-incnhojndefjdjv63md3fsbk5vo0ccvc.apps.googleusercontent.com'}
                            developerKey={'AIzaSyDrDdmRMzPZdInG6O9uTVrfslh82gXBcAc'}
                            scope={['https://www.googleapis.com/auth/drive.file']}
                            onChange={data => this.onDriveSelectDataChange(data)}
                            onAuthFailed={data => console.log('on auth failed:', data)}
                            multiselect={false}
                            navHidden={false}>
                            <div className={"drive-select-btn " + driveButtonStyles}>
                              {
                                driveSelectedFlag === 1 ? (
                                  <CloudDone className="icon" />
                                ) : driveSelectedFlag === 2 ? (
                                  <CloudOff className="icon" />
                                ) : (
                                  <img src="https://www.gstatic.com/images/branding/product/1x/drive_48dp.png" className="icon"/>
                                )
                              }
                              <span>{driveButtonText}</span>
                            </div>
                          </GooglePicker>
                        ) : (<span className="file-or-option spaced" onClick={()=>this.setState({isFileSelectOpen: true})}>Choose file from your Google Drive</span>)
                      }

                      <div className="custom-hr"><span className="file-or">or</span></div>

                      {
                        isFileSelectOpen ? (
                          <span className="file-or-option" onClick={()=>this.setState({isFileSelectOpen: false})}>Enter Google Drive file link</span>
                        ) : (
                          <div className="file-url-container">
                            <input 
                              type="url" 
                              placeholder="Paste Google Drive file link here" 
                              className={inputOneStyles}
                              value={fileUrlInput}
                              onChange={this.handleFileURLTextChange.bind(this)} />
                            <div className={`get-file-btn ${inputOneStyles}`} onClick={this.verifyDriveFile.bind(this)}>
                              <CloudDone className="icon" />
                              <span>{ driveLinkValid ? driveFile.title : input_errors[0] ? "Couldn't get your file" : "Click to verify file link"}</span>
                            </div>
                          </div>
                        )
                      }

                    </div>
                    <div className="question-container">
                      <div className="question-text-container">
                        <span className="question-text">Download Name</span>
                        {/* <span className="what-action">?</span> */}
                      </div>
                      <input 
                        type="url" 
                        placeholder="Enter a name for the download page" 
                        className={inputTwoStyles}
                        value={fileNameInput}
                        onChange={this.handleFileNameTextChange.bind(this)}/>
                    </div>
                    <div className="question-container">
                      <div className="question-text-container">
                        <span className="question-text">Download Description</span>
                        {/* <span className="what-action">?</span> */}
                      </div>
                      <textarea 
                        type="url" 
                        placeholder="Enter a description for the download" 
                        className={inputThreeStyles}
                        value={fileDescriptionInput}
                        onChange={this.handleFileDescriptionTextChange.bind(this)}/>
                    </div>
                    {/* <div className="question-container">
                      <div className="question-text-container">
                        <span className="question-text">Payge Expiry</span>
                      </div>
                      <ul className="expiry-options">
                        <li className="active">No Expiry</li>
                        <li>Choose expiration date</li>
                      </ul>
                    </div> */}
                    <div className="question-container">
                      <div className="question-text-container">
                        <span className="question-text">Payge Theme</span>
                      </div>
                      <ul className="themes">
                        <li className={theme_one_style} onClick={() => this.setSelectedTheme("one")}>
                          <div style={{display:'flex', alignItems: 'center', flex: 1, justifyContent: 'center'}} >
                            <div className="one" />
                          </div>
                        </li>
                        <li className={theme_two_style} onClick={() => this.setSelectedTheme("two")}>
                          <div className="two" />
                        </li>
                        <li className={theme_three_style} onClick={() => this.setSelectedTheme("three")}>
                          <div className="three" />
                        </li>
                      </ul>
                    </div>
                    <div className="question-container">
                      <div className="question-text-container">
                        <span className="question-text">Payge Background Image</span>
                      </div>
                      <div className="img-search-bar">
                        <input 
                          type="text" placeholder="Search for background images..."
                          onChange={this.handleImageSearchTextChange.bind(this)}
                          onKeyDown={this.handleOnKeyDown} />
                        <SearchSharp className="icon" ref="imgSearchInput" onClick={() => this.getUnsplashImages(img_search_text)} />
                      </div>
                      <ul className="backgrounds">
                        {
                          backgrounds.slice(0, 40).map((bg, index) => {
                            let liStyle = "inactive"
                            if (index === selected_bg.index) {
                              liStyle = "active"
                            }
                            return (
                              <li className={liStyle} onClick={() => this.selectBg(index)}>
                                <img src={bg.urls.thumb} />
                              </li>
                            )
                          })
                        }
                      </ul>
                      <span className="unsplash-attributions">Photos by respective artists on <a href="https://unsplash.com" target="_blank">Unsplash</a></span>
                    </div>

                    <span className="preview-text">Payge Preview</span>
                    <span className="device-support">Please use the desktop version for Payge preview.</span>
                    <div className={"preview-container " + selected_theme}>
                      <img src={selected_bg.urls.regular} className="preview-bg" />
                      <PaygeItem theme={selected_theme} name={fileNameInput} description={fileDescriptionInput} isLoaded={true} driveFile={driveFile} isDemo={true} />
                    </div>

                    <div className="create-btn" onClick={()=>this.handleCreatePayge()}>
                      <span>Create Payge</span>
                      <DoneAll className="icon" />
                    </div>
                  </section>): 
                  
                isPipelineFlow ? (

                  <>
                    <div className="mobile-support">You'll need the desktop version to create a new Payge. We'll be bringing mobile real soon! :)</div>
                    <section id="creator-flow-section">
                      <ul className="pipeline">
                        {
                          pipelineSteps.map((step, index) => {
                            let currentStyles = 'inactive'
                            if (index <= pipelineStep) {
                              currentStyles = 'active'
                            }
                            return (
                              <li className={`${currentStyles} ${pipeline_errors[index]}`}>
                                {step}
                                {
                                  pipelineStepStates[index] === 1 ? (<CheckCircle className="green-icon"/>):
                                  pipelineStepStates[index] === 2 ? (<Cancel className="red-icon"/>): 
                                  pipelineStep === pipelineSteps.length-1 && !is_loading ? (<CheckCircle className="blue-icon"/>) :false
                                }
                              </li>
                            )
                          })
                        }
                      </ul>
                      <div className="creator-flow-content">
                        { currentPipelineElement }
                      </div>
                    </section>
                    <section className={`bottom-navbar ${is_loading}`}>
                      <div className="back-btn" onClick={this.handlePipelineBack.bind(this)}>
                        <ArrowBack className="icon"/>
                        <span>
                          {pipelineStep === pipelineSteps.length-1 ? 'Go to Dashboard': 'Back'}
                        </span>
                      </div>
                      <div 
                        className={`next-btn ${pipelineStep === pipelineSteps.length-2}`} 
                        onClick={this.handlePipelineNext.bind(this)}>
                        {
                          pipelineStep === pipelineSteps.length-2 ? (<><span>Create Payge</span><DoneAll /></>):
                          pipelineStep === pipelineSteps.length-1 ? (<><span>See your Payge</span><OpenInBrowser /></>) 
                          : (<><span>Next</span><ArrowForward /></>)
                        }
                        
                      </div>
                    </section>
                  </> 

                ): !is_loading && new_payge_data ? (
                  <section id="done-section">
                    <div className="content">
                      <div className="status-container">
                        <CheckCircle className="done-icon"/>
                        <span className="done-text">Your download Payge is ready!</span>
                      </div>
                      <div className="link-container">
                        <a href={new_payge_data.paygeUrl} target="_blank" style={{textDecoration: 'none'}}>
                          <span className="link"><span className="payge-url-text">Payge URL —&nbsp;</span><b>{new_payge_data.paygeUrl}</b></span>
                        </a>
                        <span className="copy" onClick={()=>this.copyLinkToClipboard(new_payge_data.paygeUrl)}>{copyLabelText}</span>
                      </div>
                    </div>

                    <div className="back-btn">
                      <ArrowBack className="icon" />
                      <Link to="/dashboard" style={{textDecoration: 'none'}}><span>Back to Dashboard</span></Link>
                    </div>
                  </section>
                ) : (
                  <>
                    <div class="shimmer-container">
                      <div className="name shimmer" />
                      <div className="description shimmer" />
                      <div className="description shimmer" />
                      <div className="description shimmer" />
                      <div className="description shimmer short" />
                    </div>
                  </>
                )
              }

              <Modal
                isOpen={ video_isopen }
                ariaHideApp={false}
                contentLabel="How to?"
                style={yt_modal_styles}
                id="yt-video-modal">
                <div id="headerPopup" class="mfp-hide embed-responsive embed-responsive-21by9">
                  <iframe class="embed-responsive-item" width="854" height="480" src="https://www.youtube.com/embed/WiAS15V6sXs?autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
                </div>
              </Modal>

              {/* <section id="footer-section">
                <img src={yashLogo} className="yash-logo" />
              </section> */}
            </div>
          ) : false
        }

      </>
    )
  }

}